import type { components, paths } from '@core/types/clients/game-session'
import { GAME_SESSION_BASE_URL, useCoreConfig, useOpenapi } from '#imports'

type WinData = components['schemas']['WinData']
type ListWinsQuery = NonNullable<paths['/public/wins']['get']['parameters']['query']>

export interface UseGameWinsClientReturn {
    /** Wins of the site's brand from game-session's public win list. */
    listWins: (query: Omit<ListWinsQuery, 'brands'>, signal?: AbortSignal) => Promise<WinData[]>
}

export const useGameWinsClient = (): UseGameWinsClientReturn => {
    const { site } = useCoreConfig()
    const client = useOpenapi<paths>({ baseUrl: GAME_SESSION_BASE_URL, service: 'gameSession', reportErrors: false })

    async function listWins(query: Omit<ListWinsQuery, 'brands'>, signal?: AbortSignal) {
        const { data } = await client.GET('/public/wins', {
            signal,
            params: { query: { brands: [site.brand], ...query } },
            querySerializer: laravelQuery,
        })

        return data?.wins ?? []
    }

    return { listWins }
}

// Laravel only reads arrays as `key[]=a&key[]=b`; openapi-fetch's default `key=a&key=b` fails validation.
function laravelQuery(query: Record<string, unknown>) {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null) continue
        if (Array.isArray(value)) value.forEach(item => params.append(`${key}[]`, String(item)))
        else params.append(key, String(value))
    }

    return params.toString()
}
